// extracted by mini-css-extract-plugin
export default {"outerContainer":"skipModule_outerContainer__O+v4P"};